<template>
  <div class="bidding_content">
    <div class="bidding_content_banner">
      <el-breadcrumb separator-icon="ArrowRight">
        <el-breadcrumb-item :to="{ path: '/' }">当前位置：首页</el-breadcrumb-item>
        <el-breadcrumb-item>招标公告</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="bidding_content_head">
      <div class="head_condition">
        <div class="color" style="margin-left:50px;">按条件搜索:</div>
        <div v-for="(i,index) in Makes" :key="i.value" class="active" :class="index==activeBox_bgc?'active_bgc':''" @click="activeBox(index,i.value)">{{i.label}}</div>
        <div style="padding:20px 0 0 50px;">共找到 <span style="color: rgba(255, 84, 84, 1);">{{Total}}</span> 条相关信息</div>
      </div>
      <div class="head_condition_t">
        <div class="color" style="margin-left:65px;">公告类型:</div>
        <div v-for="i in LiData" :key="i.code" class="active" :class="i.code==activeBox_bgc_t?'active_bgc':''" @click="activeBox_t(i.code,i.title)">{{i.title}}</div>
        <div class="HistoricalTenders" @click="jumpWeb">点击查看历史{{ jump_text }}</div>
      </div>
      <div class="head_condition_s">
        <div class="color" style="margin-left:65px;">项目来源:</div>
        <div v-for="(i,index) in Makes3" :key="i.code" class="active" :class="index==activeBox_bgc_s?'active_bgc':''" @click="activeBox_s(index,i.value)">{{i.label}}</div>
        <div style="display: flex;font-size: 14px;padding: 15px 0 0 80px;align-items: center;">
          <div>关键字：</div>
          <div style="width: 16.25rem;height:30px;display: flex;align-items: center;">
            <el-input v-model="input" placeholder="请输入搜索关键字" prefix-icon="Search" size="small" />
            <el-button type="primary" style="background: rgba(11, 49, 76, 1);border: 1px solid rgba(11, 49, 76, 1);" @click="search">搜索</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="bidding_content_mesage">
      <div v-for="i in loadData" :key="i.tbId" style="padding-bottom: 40px;cursor: pointer;" @click="AnnouncementDetails(i.bulletinType,i.tbId)">
        <div class="mesage_title">
          <div style="display: flex;align-items: center;">
            <div style="background: rgba(0, 82, 136, 1);color: #fff;padding: 5px;">{{i.bulletinTypeName}}</div>
            <div style="display: flex;margin-left: 10px;">
              <div>{{i.bulletinName}}</div>
              <div style="color: rgb(255, 84, 84);">【剩余<span>{{ i.residueDays == -1 ? "0" : i.residueDays  }}</span> 天】</div>
            </div>
          </div>
          <div style="color: rgba(153, 153, 153, 1);">{{ i.publishTime.slice(0,11) }}</div>
        </div>
        <div class="mesage_content">
          <div class="color">公告详情：</div>
          <div class="overflow" v-html="$options.filters.ellipsis(i.bulletinContent)"></div>
        </div>
        <div class="mesage_bottom">
          <div class="display">
            <div class="color">项目类型：</div>
            <div class="color1">{{i.tdrPrjClassifyName}}</div>
          </div>
          <div class="display">
            <div class="color">项目所在地：</div>
            <div class="color1">{{i.regionName}}</div>
          </div>
          <div class="display">
            <div class="color">项目来源：</div>
            <div class="color1">{{i.businessTypeName}}</div>
          </div>
        </div>
      </div>
      <div style="display: flex;justify-content: end;">
        <el-pagination v-model:currentPage="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" :disabled="disabled" layout="total, sizes, prev, pager, next, jumper" :total="Total"
          background @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, reactive, ref } from "vue";
import { BiddingTableStore } from "@/store";
import { storeToRefs } from "pinia";
import router from '@/router';
import { findAicByAtiId, findBusinessTypeByAtiId, pageFindTenderBulletinList } from '@/api/index.js';
export default {
  filters: {
    ellipsis(value) {
      value = value.replace(/<\/?.+?>/g, "");
      value = value.replace(/ /g, " ");
      value = value.replace(/.*?\}/g, " ");
      value = value.replace(/.*?\}/g, "");
      return value;
    },
  },
  setup() {
    const LiData = [
      {
        title: "全部",
        code: "",
      },
      {
        title: "招标公告",
        code: "0",
      },
      // {
      //   title: "变更公告 ",
      //   code: "1",
      // },
      {
        title: "变更澄清",
        code: "2",
      },
      {
        title: "异常公告",
        code: "3",
      },
      {
        title: "中标公告",
        code: "4",
      },
    ];
    const Makes = ref()
    const MakesArr = async () => {
      const res = await findAicByAtiId()
      res.data.unshift({ arrtibutes: {}, label: '全部', pid: '0', value: '' })
      Makes.value = res.data
    }
    const Makes3 = ref()
    const MakesArr3 = async () => {
      const res = await findBusinessTypeByAtiId()
      res.data.unshift({ arrtibutes: {}, label: '全部', pid: '0', value: '' })
      Makes3.value = res.data
    }
    const activeBox_bgc = ref()
    const activeBox_bgc_value = ref()
    const activeBox_bgc_t = ref()
    const activeBox_bgc_s = ref()
    const activeBox_bgc_s_value = ref()
    const activeBox = (index, value) => {
      activeBox_bgc.value = index !== undefined ? index : 0;
      activeBox_bgc_value.value = value
      NewsTitle()
    }
    const jump_text= ref('招标信息')
    const activeBox_t = (index,title) => {
      activeBox_bgc_t.value = index !== undefined ? index : '';
      jump_text.value=title=='全部'?'招标信息':title
      NewsTitle()
    }
    const activeBox_s = (index, value) => {
      activeBox_bgc_s.value = index !== undefined ? index : 0;
      activeBox_bgc_s_value.value = value
      NewsTitle()
    }
    const AnnouncementDetails = (Type, Id) => {
      router.push({ path: '/AnnouncementDetails', query: { bulletinType: Type, tbId: Id } })
    }
    const setType = (item) => {
      BiddingTableStore().setData("type", item.code);
      BiddingTableStore().reloadTableData();
    };
    const activeType = computed(() => storeToRefs(BiddingTableStore()).type);
    const input = ref('')
    const search = () => {
      NewsTitle()
    }
    const currentPage = ref(1)
    const pageSize = ref(10)
    const disabled = ref(false)
    const handleSizeChange = (val) => {
      pageSize.value = val
      NewsTitle()
    }
    const handleCurrentChange = (val) => {
      currentPage.value = val
      NewsTitle()
    }
    const loadData = ref([])
    const Total = ref(1)
    const NewsTitle = async () => {
      const rows = await pageFindTenderBulletinList({ currentPage: currentPage.value || 1, pageSize: pageSize.value || 10, businessType: activeBox_bgc_s_value.value, bulletinType: activeBox_bgc_t.value, tdrPrjClassifyId: activeBox_bgc_value.value, keyWord: input.value })
      Total.value = rows.total
      loadData.value = rows.rows
    }

    const urlJump=[
      {url:'http://www.zjjryjt.cn/news/32/',index:''},
      {url:'http://www.zjjryjt.cn/news/33/',index:'0'},
      {url:'http://www.zjjryjt.cn/news/33/',index:'1'},
      {url:'http://www.zjjryjt.cn/news/33/',index:'2'},
      {url:'http://www.zjjryjt.cn/news/36/',index:'3'},
      {url:'http://www.zjjryjt.cn/news/34/',index:'4'},
    ]
    const jumpWeb =()=>{
      for(let i=0;i<urlJump.length;i++){
        if(urlJump[i].index==activeBox_bgc_t.value){
          window.open(urlJump[i].url,"_blank");
        }
      }
    }
    onMounted(async () => {
      activeBox()
      activeBox_s()
      activeBox_t('', '招标信息')
      await MakesArr()
      await MakesArr3()
      await NewsTitle()
    })
    const data = reactive({
      LiData,
      AnnouncementDetails
    });
    return {
      ...data,
      jump_text,
      urlJump,
      search,
      activeType,
      Total,
      input,
      activeBox,
      activeBox_t,
      activeBox_s,
      setType,
      handleSizeChange,
      handleCurrentChange,
      currentPage,
      pageSize,
      disabled,
      activeBox_bgc,
      activeBox_bgc_t,
      activeBox_bgc_s,
      Makes,
      MakesArr,
      Makes3,
      MakesArr3,
      loadData,
      NewsTitle,
      activeBox_bgc_value,
      activeBox_bgc_s_value,
      jumpWeb
    };
  },
  // methods: {
  //   active(index) {
  //     this.active = index;
  //   },
  // }
};
</script>

<style scoped>
@import url("./content.css");
/deep/ .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px var(--el-input-hover-border-color) inset;
}
.demo-pagination-block + .demo-pagination-block {
  margin-top: 10px;
}
.demo-pagination-block .demonstration {
  margin-bottom: 16px;
}
</style>